import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PreCandidato } from '../models/preCandidato.model';
import { catchError } from 'rxjs/operators';
import { PreCandidatoCsvDTO } from '../models/preCandidatoCsvDTO.model';
import { Aprovacao } from '../models/aprovacao.model';

@Injectable({
  providedIn: 'root'
})
export class PreCandidatosService {
  configHeader: { headers: { Authorization: any; }; };

  precandidatos: PreCandidato[] = [];
  total: number;

  constructor(
    private http: HttpClient
  ) { }

  // public getById(id: number): Observable<Candidato> {
  //   return this.http.get<Candidato>(`${environment.url_api}/candidatos/${id}`)
  // }

  public getAll(): Observable<PreCandidato[]> {
    return this.http.get<PreCandidato[]>(`${environment.url_api}/precandidatos`)
  }



  public getPreCandidatoPorIdCargo(idCargo: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/by-cargo?idCargo=${idCargo}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }

  public getPreCandidatoAprovacaoPorIdCargo(idCargo: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/aprovacoes-by-cargo?idCargo=${idCargo}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }

  public getPreCandidatoEmAnalisePorIdCargo(idCargo: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/em-analise-by-cargo?idCargo=${idCargo}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }

  public getPreCandidatoAnalisadosPorIdCargo(idCargo: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/analisado-by-aprovador?idCargo=${idCargo}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }

  insercaoEmMassaPreCandidatos(precandidatos: PreCandidatoCsvDTO[], token: any){
    console.log(precandidatos, "precandidatos ")
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/precandidatos/bulk`, precandidatos, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  excluirPreCandidatoEleicao(idPreCandidato: Number, token){
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.delete(`${environment.url_api}/precandidatos/${idPreCandidato}`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }
  getPreCandidadosById(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/${id}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }

  getPreCandidatosByIdEleicao(idCandidatura: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/by-candidatura?idCandidatura=${idCandidatura}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error.message);
            }
        )
    })
  }

  getPreCandidatosByIdEleicaoGestor(idCandidatura: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/by-candidatura-gestor?idCandidatura=${idCandidatura}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error.message);
            }
        )
    })
  }

  getPreCandidatosForRelatorio(idCandidatura: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/by-candidatura-for-relatorio?idCandidatura=${idCandidatura}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error.message);
            }
        )
    })
  }

  getPreCandidatosByIdEleicaoLite(idCandidatura: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/precandidatos/by-candidatura/lite?idCandidatura=${idCandidatura}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error.message);
            }
        )
    })
  }

  public cadastrarPreCandidato(precandidato: PreCandidato, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/precandidatos`, precandidato, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public editarPreCandidato(precandidato: PreCandidato, token, idPreCandidato: Number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/precandidatos/${idPreCandidato}`, precandidato, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public editarPreCandidatoFormulario(precandidato: PreCandidato, token, idPreCandidato: Number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/precandidatos/${idPreCandidato}/formularioPreCandidato`, precandidato, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public deferirPreCandidato(aprovacao: Aprovacao, idPreCandidato: number, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/precandidatos/deferir?preCandidatoId=${idPreCandidato}`, aprovacao, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public alterarDeferirPreCandidato(aprovacao: Aprovacao, idPreCandidato: number, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/precandidatos/alterarDeferir?preCandidatoId=${idPreCandidato}`, aprovacao, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public indeferirPreCandidato(aprovacao: Aprovacao, idPreCandidato: number, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/precandidatos/indeferir?preCandidatoId=${idPreCandidato}`, aprovacao, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public alterarIndeferirPreCandidato(aprovacao: Aprovacao, idPreCandidato: number, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/precandidatos/alterarIndeferir?preCandidatoId=${idPreCandidato}`, aprovacao, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public findAllPreCandidatosByCandidaturaIdPage(candidaturaId: number,linesPerPage:number,page: number, login: string, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get<PreCandidato[]>(`${environment.url_api}/precandidatos/page?candidaturaId=${candidaturaId}&linesPerPage=${linesPerPage}&page=${page}&login=${login}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

}
